import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../shared/source/context/context';
import { userJobRelevantSkillsSchema } from '../../../../../shared/source/data-contract/user-job';

import type { UserJobRelevantSkills } from '../../../../../shared/source/data-contract/user-job';
import type { Pathname } from '../../../../../shared/source/http-fetcher/http-fetcher';
import type { UseQueryResult } from '@tanstack/react-query';

export const useCandidateMatchingInfoQuery = ({
    enabled,
    jobId,
    userId,
}: {
    readonly enabled: boolean;
    readonly jobId: string;
    readonly userId: string;
}): UseQueryResult<UserJobRelevantSkills> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    const pathname: Pathname = `/jobs/${jobId}/candidates/${userId}/matching`;

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(userJobRelevantSkillsSchema, {
                pathname,
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },

        queryKey: [pathname, 'GET'],
    });
};
